import { Model, Attr, BelongsTo, HasMany } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import request from '@/utils/request'
import { Customer, GiftCard, Card, MultiChoiceCard } from '@/models/index'

@Model()
export default class Gift extends ApplicationRecord {
  static jsonapiType = 'gifts'

  static MAX_EMAIL_RESENDS = 3

  @Attr() id!: string
  @Attr() message!: string
  @Attr() createdAt!: string
  @Attr() updatedAt!: string
  @Attr() cardDistributions!: any
  @Attr() giftCardId!: string
  @Attr() status!: string

  @Attr() recipientEmail!: string
  @Attr() recipientFirstname!: string
  @Attr() recipientLastname!: string
  @Attr() emailOpenedAt!: string
  @Attr() emailDeliveredAt!: string
  @Attr() emailFailedAt!: string | null
  @Attr() emailFailureReason!: string | null
  @Attr() emailResendCount!: number
  @Attr() redemptionCodeGeneratedAt!: string | null

  @BelongsTo() sender!: any
  @BelongsTo() recipient!: Customer
  @BelongsTo() giftCard!: GiftCard

  @HasMany() cards!: Card[]
  @HasMany() multiChoiceCards!: MultiChoiceCard[]

  public static async resendEmail(giftId: string, email: string): Promise<void> {
    await request.put(`/market/v1/gifts/${giftId}/resend_email`, {
      data: {
        id: giftId,
        type: 'gifts',
        email
      }
    })
  }

  public static async downloadRedemptionPdf(giftId: string): Promise<void> {
    const pdf = await request.get(`/market/v1/gifts/${giftId}/redemption_pdf`, {
      responseType: 'blob',
      timeout: 30000 // first call generates the PDF and uploads it, can take more than the default 5s
    })
    const blob = new Blob([pdf as any], { type: 'application/pdf' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.setAttribute('href', url)
    link.setAttribute('download', `bon-${giftId}.pdf`)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  public getColorByName() {
    let name = ''
    let hash = 0

    if (this.recipient?.firstname && this.recipient?.lastname) name = this.recipient.firstname + this.recipient.lastname

    if (name.length === 0) return hash
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash)
      hash = hash & hash
    }
    let color = '#'
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 255
      color += ('00' + value.toString(16)).substr(-2)
    }
    return color
  }
}
